import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="flex min-h-[60vh] items-center justify-center"
        data-testid="admin-loading"
      >
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-apicon-navy/20 border-t-apicon-navy" />
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
};

export default AdminRoute;
